import { ValidatorFn, Validators } from '@angular/forms';

export class CorpDataFormOption {
    validators?: ValidatorFn[] | null;
    defaultDisabled?: boolean = false;
    defaultValue?: any;
}

export const requiredDisabled: CorpDataFormOption = { validators: [Validators.required], defaultDisabled: true, defaultValue: null };
export const disabled: CorpDataFormOption = { validators: null, defaultDisabled: true, defaultValue: null };
export const required: CorpDataFormOption = { validators: [Validators.required], defaultDisabled: false, defaultValue: null };